'use client';
import { isString } from '@s7/utils';

// TODO: move system
// TODO: описать назначение
var createIdGuard = function(uid, errorMessage) {
    return function(value) {
        if (!isString(value) || value.trim().length === 0) {
            throw new Error(errorMessage);
        }
        return uid + "-" + value;
    };
};

export { createIdGuard };
